var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-wordmark-a",
    x1: ".98",
    x2: ".601",
    y1: ".002",
    y2: ".419"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".176",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-wordmark-b",
    x1: "1.006",
    x2: ".566",
    y1: ".003",
    y2: ".46"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".176",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-.029 37h128v54h-128z",
    fill: "#FFF",
    fillOpacity: ".012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.479 47.352h4.769v23.62c0 6.227-2.836 10.575-9.418 10.575-2.473 0-4.406-.41-5.734-.883v-4.523c1.449.59 3.199.882 4.949.882 4.047 0 5.434-2.351 5.434-5.757V47.352zm13.527-1.825c1.87 0 3.2 1.118 3.2 3.118 0 1.937-1.33 3.113-3.2 3.113-1.871 0-3.2-1.117-3.2-3.113 0-1.942 1.329-3.118 3.2-3.118zm-2.356 9.934h4.59v25.852h-4.59V55.46zm15.938 25.852h-4.465V55.46h4.465v4.523c1.57-3.054 4.226-5.23 9.422-4.937v4.348c-5.86-.586-9.422 1.117-9.422 6.64v15.278zm30.855-4.641c-1.691 3.406-4.89 5.168-8.996 5.168-7.066 0-10.629-5.817-10.629-13.453 0-7.285 3.746-13.457 11.172-13.457 3.864 0 6.883 1.703 8.453 5.054v-4.523h4.586v25.851h-4.586v-4.64zm-7.789 1.055c4.106 0 7.727-2.524 7.727-8.286v-2.054c0-5.758-3.32-8.285-7.246-8.285-5.13 0-7.785 3.289-7.785 9.285.058 6.226 2.593 9.34 7.304 9.34zm0 0",
    fill: "#253858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.51 42.063H20.62c0 5.054 4.226 9.167 9.417 9.167h3.867v3.583c0 5.054 4.227 9.167 9.418 9.167V43.824c0-.996-.785-1.762-1.812-1.762zm0 0",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.186 52.168H10.295c0 5.055 4.226 9.168 9.418 9.168h3.863v3.64c0 5.055 4.227 9.169 9.422 9.169V53.93c0-.938-.785-1.762-1.812-1.762zm0 0",
    fill: "url(#jira-original-wordmark-a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.861 62.332H-.029c0 5.055 4.226 9.168 9.418 9.168h3.863v3.582c0 5.055 4.227 9.168 9.422 9.168V64.098c0-1-.848-1.766-1.813-1.766zm0 0",
    fill: "url(#jira-original-wordmark-b)"
  }));
};